import { string, func, bool, oneOf } from "prop-types";
import { Cached } from "@material-ui/icons";
import { TooltipIcon } from "@components";
import classnames from "classnames";

export const ResetValueButton = ({
  action,
  children,
  className,
  disabled,
  size="large"
}) => (
  <TooltipIcon
    icon={<Cached className={classnames(!disabled && "color-warning")} />}
    onClick={action}
    className={classnames(
      "noDrag p-0-5",
      size === "large" ? "text-md" : "text-sm",
      className
    )}
    disabled={disabled}
  >
    {children}
  </TooltipIcon>
);

ResetValueButton.propTypes = {
  action: func.isRequired,
  children: string.isRequired,
  className: string,
  disabled: bool,
  size: oneOf(["small", "large"]),
};
